module.exports = __webpack_public_path__ + "img/Products_Desktop_09.6c86883b.jpg";